import type {ReactElement} from 'react';
import type {AiGenerationListItemProps} from './ai-generation-list-item.types';
import {AiGenerationListItemState} from './ai-generation-list-item.types';
import styles from './ai-generation-list-item.module.scss';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick/skeleton-brick';
import {ClickableDiv} from '@Components/clickable-div';
import {noop} from '@Utils/general.util';

const SKELETON_BRICK_TOP_WIDTH = '100%';
const SKELETON_BRICK_BOTTOM_WIDTH = '35%';

const THEME_MAPPING = {
  [AiGenerationListItemState.GENERATING]: SkeletonBrickTheme.AI_CYCLING_GRADIENT,
  [AiGenerationListItemState.LOADING]: SkeletonBrickTheme.LIGHT,
};

export function AiGenerationListItem({
  content,
  state = AiGenerationListItemState.DEFAULT,
  onClick = noop,
  className = '',
}: AiGenerationListItemProps): ReactElement {
  if (state !== AiGenerationListItemState.DEFAULT) {
    const theme = THEME_MAPPING[state];

    return (
      <div className={`${styles.listItem} ${className}`}>
        <div className={styles.skeletonLines}>
          <SkeletonBrick theme={theme} width={SKELETON_BRICK_TOP_WIDTH} />
          <SkeletonBrick theme={theme} width={SKELETON_BRICK_BOTTOM_WIDTH} />
        </div>
      </div>
    );
  }

  return (
    <ClickableDiv className={`${styles.listItem} ${styles.selectable} ${className}`} onClick={onClick}>
      {content}
    </ClickableDiv>
  );
}
